import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
  OnDestroy,
} from "@angular/core";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MY_FORMATS } from "../../shared/services/util.service";
import { MatCalendar } from "@angular/material/datepicker";
import { NgClass } from "@angular/common";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import moment from "moment";
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from "@angular/forms";

/** Custom header component for datepicker. */
@Component({
  selector: "custom-header",
  styles: [
    `
      .example-header {
        display: flex;
        align-items: center;
        padding: 0.5em;
      }

      .example-header-label {
        flex: 1;
        height: 1em;
        font-weight: 500;
        text-align: center;
      }

      .example-double-arrow .mat-icon {
        margin: -22%;
      }
    `,
  ],
  template: `
    <div class="example-header">
      <button
        mat-icon-button
        class="example-double-arrow"
        (click)="previousClicked('year')"
      >
        <mat-icon>keyboard_arrow_left</mat-icon>
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button (click)="previousClicked('month')">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <span class="example-header-label">{{ periodLabel }}</span>
      <button mat-icon-button (click)="nextClicked('month')">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
      <button
        mat-icon-button
        class="example-double-arrow"
        (click)="nextClicked('year')"
      >
        <mat-icon>keyboard_arrow_right</mat-icon>
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MaterialModule],
  standalone: true,
})
export class CustomHeader<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
    private _calendar: MatCalendar<D>,
    private _dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
    cdr: ChangeDetectorRef,
  ) {
    _calendar.stateChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => cdr.markForCheck());
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  get periodLabel() {
    return this._dateAdapter
      .format(
        this._calendar.activeDate,
        this._dateFormats.display.monthYearLabel,
      )
      .toLocaleUpperCase();
  }

  previousClicked(mode: "month" | "year") {
    this._calendar.activeDate =
      mode === "month"
        ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1)
        : this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  nextClicked(mode: "month" | "year") {
    this._calendar.activeDate =
      mode === "month"
        ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1)
        : this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }
}

@Component({
  selector: "app-cim-datepicker",
  templateUrl: "./cim-datepicker.component.html",
  styleUrls: ["./cim-datepicker.component.scss"],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  imports: [MaterialModule, FormsModule, NgClass],
  standalone: true,
})
export class CimDatepickerComponent implements OnInit {
  @Input() model: any;
  @Input() label: string;
  @Input() minDate: any;
  @Input() maxDate: any;
  @Input() isRequired = false;
  @Input() isFullWidth = false;
  @Input() isInTableHeader = false;
  @Output() modelChanged: EventEmitter<any>;

  customHeader = CustomHeader;
  t = moment();

  today = moment(this.t.startOf("day")).set("date", this.t.get("date") - 1);

  constructor() {
    this.modelChanged = new EventEmitter<any>();

    if (this.t.day() == 1)
      this.today = moment(this.t.startOf("day")).set(
        "date",
        this.t.get("date") - 3,
      );
  }

  ngOnInit(): void {}

  onDateChange() {
    if (this.model) {
      this.model = this.model.format("YYYY-MM-DD");
    }
    this.modelChanged.emit(this.model);
  }
}
